import { EventTypes, emitter } from '@services/emitter';

interface ScrollPayloadRawCoords {
  x: number;
  y: number;
}

interface RemoteScrollingPayload {
  raw: ScrollPayloadRawCoords;
  proportional: number;
}

/**
 *
 * since scrollY is measured from the top of the viewport we should
 * subtract the viewport height from the total document height to get
 * an accurate upper bound
 *
 *  ┌─┬────────────┐  │ scrollHeight
 *  │ │            │  │
 *  │ │            │  │
 *  │ │ scrollY    │  │
 *  │ │            │  │
 *  │ │            │  │
 *  │ ▼            │  │
 * ┌────────────────┐ │ │ clientHeight
 * ││ ▲            ││ │ │
 * ││ └── maxScroll││ │ │
 * ││              ││ │ │
 * ││              ││ │ │
 * ││              ││ │ │
 * └────────────────┘ │ │
 */
const getMaxScrollHeight = () => {
  const docElement = document.documentElement;
  const maxScroll = docElement.scrollHeight - docElement.clientHeight;
  return maxScroll;
};

const getScrollPercent = () => {
  const scrollPosition = window.scrollY;
  const maxScroll = getMaxScrollHeight();

  return scrollPosition / maxScroll;
};

const setScroll = (payload: RemoteScrollingPayload) => {
  emitter.emit(EventTypes.RemoteScrolling, payload);

  const maxScroll = getMaxScrollHeight();
  const y = maxScroll * payload.proportional;

  document.documentElement.scrollTo(0, y);
};

export { getMaxScrollHeight, getScrollPercent, setScroll };
export type { ScrollPayloadRawCoords, RemoteScrollingPayload };
